/**
 * Shared formatting utilities for prediction market components
 */

export function formatPct(val) {
    if (val === null || val === undefined) return '—';
    return Number(val).toFixed(1) + '%';
}

export function formatPrice(val) {
    if (val === null || val === undefined) return '—';
    return Number(val).toFixed(4);
}

export function formatVolume(val) {
    if (!val) return '$0';
    if (val >= 1_000_000_000) return '$' + (val / 1_000_000_000).toFixed(1) + 'B';
    if (val >= 1_000_000) return '$' + (val / 1_000_000).toFixed(1) + 'M';
    if (val >= 1_000) return '$' + (val / 1_000).toFixed(1) + 'K';
    return '$' + Number(val).toFixed(0);
}

export function capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function usePredictFormatters() {
    return { formatPct, formatPrice, formatVolume, capitalize };
}

export default usePredictFormatters;
